import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FaDownload, FaMobileAlt, FaBolt, FaBell } from 'react-icons/fa';
import { useInstall } from '../../context/InstallContext';
import './InstallSection.css';
import Button from '../UI/Button/Button';
import LanguageContext from '../../context/LanguageContext.js';

const InstallSection = () => {
    const { dir } = useContext(LanguageContext);
    const { t } = useTranslation();
    const { canInstall, isIOS, isInstalled, promptInstall } = useInstall();

    if (isInstalled) return null;

    return (
        <section className="section section--surface-1 container" id="install-app">
            <div className="install-section" dir={dir()}>
                <div className="install-section-left">
                    <span className="install-section-badge">
                        <FaDownload />
                        {t('installSection.badge', 'Free to Install')}
                    </span>

                    <h2 className="install-section-title">
                        {t('installSection.title', 'Get Our App')}
                    </h2>

                    <p className="install-section-subtitle">
                        {t('installSection.subtitle', 'Install directly from your browser — no app store needed')}
                    </p>

                    <div className="install-section-features">
                        <div className="install-section-feature">
                            <div className="install-section-feature-icon">
                                <FaBolt />
                            </div>
                            <div>
                                <h4 className="install-section-feature-title">
                                    {t('installSection.fastTitle', 'Lightning Fast')}
                                </h4>
                                <p className="install-section-feature-desc">
                                    {t('installSection.fastDesc', 'Opens instantly like a native app')}
                                </p>
                            </div>
                        </div>

                        <div className="install-section-feature">
                            <div className="install-section-feature-icon">
                                <FaMobileAlt />
                            </div>
                            <div>
                                <h4 className="install-section-feature-title">
                                    {t('installSection.homeScreenTitle', 'Home Screen Access')}
                                </h4>
                                <p className="install-section-feature-desc">
                                    {t('installSection.homeScreenDesc', 'One tap from your home screen to order')}
                                </p>
                            </div>
                        </div>

                        <div className="install-section-feature">
                            <div className="install-section-feature-icon">
                                <FaBell />
                            </div>
                            <div>
                                <h4 className="install-section-feature-title">
                                    {t('installSection.nativeTitle', 'Native Experience')}
                                </h4>
                                <p className="install-section-feature-desc">
                                    {t('installSection.nativeDesc', 'Full screen, no browser bar')}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="install-section-action">
                        {canInstall ? (
                            <Button type="button" flex className="install-section-btn" onClick={promptInstall}>
                                <FaDownload className="button-icon" />
                                {t('installSection.installBtn', 'Install Now')}
                            </Button>
                        ) : isIOS ? (
                            <div className="install-section-ios-guide">
                                <p>
                                    {t('installSection.iosStep1', 'Tap the')}
                                    {' '}
                                    <svg className="install-section-share-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                                        <polyline points="16 6 12 2 8 6" />
                                        <line x1="12" y1="2" x2="12" y2="15" />
                                    </svg>
                                    {' '}
                                    <strong>{t('installSection.iosShare', 'Share')}</strong>
                                    {' '}
                                    {t('installSection.iosStep2', 'button, then select')}
                                    {' '}
                                    <strong>{t('installSection.iosAddHome', '"Add to Home Screen"')}</strong>
                                </p>
                            </div>
                        ) : (
                            <p className="install-section-browser-note">
                                {t('installSection.browserNote', 'Open in Chrome, Edge, or Safari to install this app on your device.')}
                            </p>
                        )}
                    </div>
                </div>

                <div className="install-section-right">
                    <div className="install-section-phone">
                        <div className="install-section-phone-notch"></div>
                        <div className="install-section-phone-screen">
                            <div className="install-section-phone-header">
                                <div className="install-section-phone-dot"></div>
                                <div className="install-section-phone-dot"></div>
                                <div className="install-section-phone-dot"></div>
                            </div>
                            <div className="install-section-phone-content">
                                <div className="install-section-phone-logo">
                                    <FaMobileAlt />
                                </div>
                                <div className="install-section-phone-line install-section-phone-line--long"></div>
                                <div className="install-section-phone-line install-section-phone-line--short"></div>
                                <div className="install-section-phone-cards">
                                    <div className="install-section-phone-card"></div>
                                    <div className="install-section-phone-card"></div>
                                </div>
                                <div className="install-section-phone-cta"></div>
                            </div>
                        </div>
                    </div>
                    <div className="install-section-glow"></div>
                </div>
            </div>
        </section>
    );
};

export default InstallSection;
